import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

export const Breadcrumbs = ({ items }) => (
  <nav data-testid="breadcrumbs" aria-label="Breadcrumb" className="container-tight pt-8 text-sm">
    <ol className="flex flex-wrap items-center gap-2 text-slate-500">
      <li>
        <Link to="/" className="inline-flex items-center gap-1 hover:text-petrol">
          <Home className="h-3.5 w-3.5" /> Home
        </Link>
      </li>
      {items.map((it, i) => (
        <li key={it.href} className="inline-flex items-center gap-2">
          <ChevronRight className="h-3.5 w-3.5 text-slate-400" />
          {i === items.length - 1 ? (
            <span className="text-petrol font-medium">{it.label}</span>
          ) : (
            <Link to={it.href} className="hover:text-petrol">{it.label}</Link>
          )}
        </li>
      ))}
    </ol>
  </nav>
);
